import request from '@/utils/seftRequest';

export function qryCustDetail(params) {
  return request('/ding/custService/qryCustDetailBsnl', { params });
}

export function qryCustAddrList(params) {
  return request('/ding/custService/qryCustAddrList', { params });
}

// 根据证件Id查询证件信息
export function qryCert(params) {
  return request('/ding/custService/qryCertBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询联系人
export function qryContactMan(params) {
  return request('/ding/custService/qryContactManBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询属性联动
export function qryAttrLinkageInfoBsnl(params) {
  return request('/ding/custService/qryAttrLinkageInfoBsnl', { params });
}

// 查询属性信息接口
export function qryAttrInfoBsnl(params) {
  return request('/ding/custService/qryAttrInfoBsnl', { params });
}

// 查询可选地址列表
export function qryOssAddressListBsnl(params) {
  return request('/ding/custService/qryOssAddressListBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询移机新老地址范围对比
export function qryShiftRange(params) {
  return request('/ding/custService/qryShiftRange', {
    method: 'POST',
    body: params,
  });
}

// 校验代理商能否在该销售区域代理
export function frServiceInfoCheck(params) {
  return request('/ding/channel/frServiceInfoCheck', { params });
}

// 查询证件类型列表
export function qryCertType(params) {
  return request('/ding/custService/qryCertType', { params });
}

// 查询账户列表
export function qryAccountList(params) {
  return request('/ding/custService/qryAcctListBsnl', { params });
}

// 查询账户详情
export function qryAcctDetail(params) {
  return request('/ding/custService/qryAcctInfoBsnl', { params });
}

export function sendVerifyCode(params) {
  return request('/ding/sendVerifyCodeByPhone', {
    method: 'POST',
    body: params,
  });
}

export function validVerifyCode(params) {
  return request('/ding/validVerifyCodeByPhone', {
    method: 'POST',
    body: params,
  });
}

export function qryConfigParam(params) {
  return request(`/ding/drmConfigItemParam/${params.configCode}`);
}

export function qryConfigParams(params) {
  return request('/ding/common/drmConfigItemParams', {
    params,
  });
}

export function addCustAddress(data) {
  return request('/ding/custService/addCustAddress', {
    method: 'POST',
    body: data,
  });
}

export function downloadFile(data) {
  return request('/ding/common/download4dms', {
    method: 'POST',
    body: data,
    responseType: 'blob',
  });
}

export function qryOccupationList(params) {
  return request('/ding/custService/qryOccupationList', { params });
}

export function qrySubsDetail(data) {
  return request('/ding/subsService/qrySubsDetailBsnl', {
    method: 'POST',
    body: data,
  });
}

export function qrySubsPlanDetail(params) {
  return request('/ding/subsService/qrySubsPlanDetailBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询账单寄送方式
export function qryBilldeliveryMethod() {
  return request('/ding/acctService/qryBillDeliveryMethodBsnl');
}

// 查询账期
export function qryBillingCycleType(data) {
  return request('/ding/custService/qryBillingCycleTypeList', {
    method: 'POST',
    body: data,
  });
}

export function createAccount(data) {
  return request('/ding/custService/createAccountBsnl', {
    method: 'POST',
    body: data,
  });
}

export function qryAvailablePlanListBsnl(params) {
  return request('/ding/subsService/qryAvailablePlanListBsnl', {
    method: 'POST',
    body: params,
  });
}

export function qryOfferForChangeBrand(params) {
  return request('/ding/custService/qryOfferForChangeBrand', {
    method: 'POST',
    body: params,
  });
}

// 查询可订购的VAS
export function qryAvailableRelateOfferBsnl(params) {
  return request('/ding/subsService/qryAvailableRelateOfferBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询ISDN主号码 /drm/ding/subsService/qryEpbxIsdnNbrList
export function qryEpbxIsdnNbrList(params) {
  return request('/ding/subsService/qryEpbxIsdnNbrList', {
    params,
  });
}

// 宽带套餐带宽查询接口 /drm/ding/custService/qryPackageIdInfoBsnl
export function qryPackageIdInfo(params) {
  return request('/ding/custService/qryPackageIdInfoBsnl', {
    params,
  });
}

// 查询银行列表
export function qryBankList(params) {
  return request('/ding/acctService/qryBankListBsnl', {
    method: 'POST',
    body: params,
  });
}

// 员工pinNumber校验接口
export function checkPinNumberSame4Staff(params) {
  return request('/ding/checkPinNumberSame4Staff', {
    method: 'POST',
    body: params,
  });
}

// 查询FMC对应的fellowNbrType列表
export function qryFellowNbrType4FMCBsnl() {
  return request('/ding/subsService/qryFellowNbrType4FMCBsnl');
}

// 查询FNF的fellowNbrType
export function qryFellowNbrType4FNFBsnl() {
  return request('/ding/subsService/qryFellowNbrType4FNFBsnl');
}

// 订户成员信息详情接口 /drm/ding/subsService/qrySubsMemDetailBsnl
export function qrySubsMemDetail(data) {
  return request('/ding/subsService/qrySubsMemDetailBsnl', {
    method: 'POST',
    body: data,
  });
}

// 员工pinNumber校验接口
export function fmcFixedNumberCheck(params) {
  return request('/ding/subsService/fmcFixedNumberCheck', {
    method: 'POST',
    body: params,
  });
}

// 查询当前订户号码的欠费信息 drm/ding/custService/queryAccountBsnl
export function queryAccountBsnl(params) {
  return request('/ding/custService/queryAccountBsnl', { params });
}

// 拆机订户协议期校验、修改套餐
export function terminationCheckBsnl(params) {
  // return request('/ding/subsService/terminationCheckBsnl', { params });
  return request('/ding/subsService/agreementPeriodCheck', {
    method: 'POST',
    body: params,
  });
}

// 根据地址查询exchangeCode drm/ding/custService/qryExchangeListByAddr
export function qryExchangeListByAddr(params) {
  return request('/ding/custService/qryFrExchangeListByAddr', { params });
}

// 根据exchangeId查询StdCode drm/ding/custService/qryStdCodeListByExch
export function qryStdCodeListByExch(params) {
  return request('/ding/custService/qryStdCodeListByExch', { params });
}

// 号码locked解锁接口
export function unlockedServiceNumber(params) {
  return request('/ding/custService/operAccNbr', {
    method: 'POST',
    body: params,
  });
}
